// API Endpoints
export const PHOTO_ORDERS_API_URL = "https://photo-orders.t9e2i3kal.workers.dev/";
export const GUN_ORDERS_API_URL = "https://gun-orders-worker.t9e2i3kal.workers.dev/";
export const EMAIL_ENDPOINT = "https://dat-photo-service.duckdns.org/order/email";

// MQTT Configuration
export const MQTT_CONFIG = {
  brokerUrl: "wss://6225f5860bef41b88da4d2b83687e9b9.s1.eu.hivemq.cloud:8884/mqtt",
  username: "datkiosk-client",
  password: "QZ7P7KPCZ4Q@je4",
  topics: ["photo_orders", "gun_orders"],
  get clientId() {
    return `admin-${Math.random().toString(36).substr(2, 9)}`;
  },
};

// Package Definitions
export const GUN_PACKAGES = {
  "Vietnam Package": ["M16A1", "AK-47", "M14", "SKS", "RPD", "M60"],
  "WWII Package": ["M1 Thompson", "MP-40", "M1 Garand", "Bren", "Mosin Nagant", "DP-28", "MG42", "Sterling"],
  "Extreme Package": ["Kriss Vector", "M92", "HK-51", "Barking Chihuahua", "M82A1 Barrett", ".50 cal M2HB"],
  "Modern Warfare Package": ["P90", "Kriss Vector", "M4", "Galil", "Barrett", "M249 SAW", "M1014 Benelli"]
};

// Auth Configuration
export const AUTH_ENDPOINTS = {
  uploadAuth: "https://dat-photo-auth.t9e2i3kal.workers.dev/upload_auth",
  pricing: "https://dat-photo-admin.t9e2i3kal.workers.dev/pricing",
  refreshPages: "https://dat-photo-admin.t9e2i3kal.workers.dev/refresh_pages",
  deleteAllImages: "https://image-service-uploader.t9e2i3kal.workers.dev/delete/all",
  orderHistory: "https://dat-order-history.t9e2i3kal.workers.dev/orders"
};

// Local Storage Keys
export const STORAGE_KEYS = {
  uploadAuth: "uploadAuth",
  emailedKeys: "emailedKeys",
  printedKeys: "printedKeys",
  emailTime: "emailTime_",
  printTime: "printTime_"
};

// Time Constants
export const AUTH_VALIDITY_MS = 24 * 60 * 60 * 1000; // 24 hours
export const STATUS_VALIDITY_MS = 48 * 60 * 60 * 1000; // 48 hours